import React from 'react';
import { FiAlertTriangle, FiLogOut } from 'react-icons/fi';
import BillingSubscription from './BillingSubscription';
import { logoutAdmin } from '../utils/subscriptionAccess';
import '../styles/BillingSubscription.css';

/**
 * Shown instead of the dashboard when the company's subscription has ended.
 * Only the Super Admin gets here; the backend allows nothing but billing calls.
 */
export default function BillingOnlyShell() {
  return (
    <div className="bs-shell">
      <header className="bs-shell-top">
        <img src="/logoSas.png?v=5" alt="SAS Cleaning Suite" />
        <button type="button" onClick={logoutAdmin}>
          <FiLogOut /> Logout
        </button>
      </header>
      <main className="bs-shell-main">
        <div className="bs-banner bs-banner--warn">
          <FiAlertTriangle />
          <div>
            <strong>Your subscription has ended</strong>
            <p>
              Your team can't use SAS Cleaning Suite until it's reactivated. Your data is safe — choose a plan
              under Plans to restore access straight away, or pay any outstanding invoice under Invoices.
            </p>
          </div>
        </div>
        <BillingSubscription billingOnly />
      </main>
    </div>
  );
}
